import { SVGProps } from "react";

export function UserMetricIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      fill="none"
      viewBox="0 0 33 32"
      {...props}
    >
      <path
        stroke="#FBFDFF"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M25.42 26.065a9.337 9.337 0 00-17.49 0m17.49 0A13.302 13.302 0 0030.01 16c0-7.364-5.97-13.333-13.333-13.333C9.312 2.667 3.342 8.637 3.342 16c0 4.018 1.777 7.62 4.589 10.065m17.49 0a13.282 13.282 0 01-8.745 3.268 13.282 13.282 0 01-8.745-3.268"
      ></path>
      <circle
        cx="4"
        cy="4"
        r="4"
        stroke="#FBFDFF"
        strokeLinejoin="round"
        strokeWidth="1.5"
        transform="matrix(1 0 0 -1 12.676 16)"
      ></circle>
    </svg>
  );
}

